import { ISelectOption } from '../../../ui-toolkit';

export enum ePayerType {
  AttorneysBusinessPartner = 'attorneys_business_partner',
  Borrower = 'borrower',
  BusinessPartner = 'business_partner',
  Lender = 'lender',
  Seller = 'seller',
}

export const prettyPayerType: Record<ePayerType, string> = {
  [ePayerType.AttorneysBusinessPartner]: 'Attorneys Business Partner',
  [ePayerType.Borrower]: 'Borrower',
  [ePayerType.BusinessPartner]: 'Business Partner',
  [ePayerType.Lender]: 'Lender',
  [ePayerType.Seller]: 'Seller',
};

export const payerTypeOptions: ISelectOption[] = Object.values(ePayerType).map((payerType) => ({
  label: prettyPayerType[payerType],
  value: payerType,
}));
